<template>
    <div>
        <load-screen-component :is-loading="isLoading"></load-screen-component>
        <page-header pageTitle="PROPOSAL.INDEX" has-slot>
            <template #container>
                <div class="d-flex flex-row" >
                    <div class="card mr-1 mt-1 card-hover-scale dashboard-summary-card" title="Dashboard"
                          @click="$router.push({name:'DashboardProposal'})"
                          v-if="!widthMd(1240) && qtdProposalActive && this.$hasPermission('Dashboard_proposals', true)"
                    >
                        <div class=" pl-3 pr-3 pt-2 d-flex flex-row justify-content-between">
                            <div class="align-self-center">
                                <span><h5>{{qtdProposalActive}}</h5> </span>
                                <p style="font-size: smaller; font-weight: 600">Propostas Ativas</p>
                            </div>
                            <div class="d-flex flex-row-reverse" >
                                <svg class="apexcharts-svg" transform="translate(5, 0)" width="160" height="50">
                                    <g class="apexcharts-inner apexcharts-graphical" transform="translate(30, -5)">
                                        <defs>
                                            <filter id="SvgjsFilter1075" filterUnits="userSpaceOnUse" width="100%"
                                                    height="150%">
                                                <feOffset id="SvgjsFeOffset1068" result="offset" in="SourceGraphic"
                                                          dx="1"
                                                          dy="1"></feOffset>
                                                <feGaussianBlur id="SvgjsFeGaussianBlur1069" result="blur" in="offset"
                                                                stdDeviation="2"></feGaussianBlur>
                                                <feFlood id="SvgjsFeFlood1070" result="flood" in="SourceGraphic"
                                                         flood-color="#000000" flood-opacity="0.5"></feFlood>
                                                <feComposite id="SvgjsFeComposite1071" result="shadow" in="flood"
                                                             in2="blur"
                                                             operator="in"></feComposite>
                                                <feMerge id="SvgjsFeMerge1072" result="SvgjsFeMerge1072"
                                                         in="SourceGraphic">
                                                    <feMergeNode id="SvgjsFeMergeNode1073" result="SvgjsFeMergeNode1073"
                                                                 in="shadow"></feMergeNode>
                                                    <feMergeNode id="SvgjsFeMergeNode1074" result="SvgjsFeMergeNode1074"
                                                                 in="SourceGraphic"></feMergeNode>
                                                </feMerge>
                                            </filter>
                                        </defs>
                                        <g>
                                            <g>
                                                <path d="M 0 44C 5.1722222222222225 44 9.605555555555556 43 14.777777777777779 43C 19.950000000000003 43 24.383333333333333 49 29.555555555555557 49C 34.72777777777778 49 39.16111111111111 26.5 44.333333333333336 26.5C 49.50555555555556 26.5 53.93888888888889 34 59.111111111111114 34C 64.28333333333333 34 68.71666666666667 28 73.8888888888889 28C 79.06111111111112 28 83.49444444444445 43 88.66666666666667 43C 93.8388888888889 43 98.27222222222224 22.5 103.44444444444446 22.5C 108.61666666666667 22.5 113.05000000000001 29.5 118.22222222222223 29.5C 123.39444444444445 29.5 127.82777777777778 15.5 133 15.5"
                                                      fill="none" fill-opacity="1" stroke="rgba(255,255,255,0.85)"
                                                      stroke-opacity="1" stroke-linecap="butt" stroke-width="3"
                                                      stroke-dasharray="0" class="apexcharts-line" index="0"
                                                      clip-path="url(#gridRectMaskssa0k9x6)"
                                                      filter="url(#SvgjsFilter1075)"
                                                      pathTo="M 0 44C 5.1722222222222225 44 9.605555555555556 43 14.777777777777779 43C 19.950000000000003 43 24.383333333333333 49 29.555555555555557 49C 34.72777777777778 49 39.16111111111111 26.5 44.333333333333336 26.5C 49.50555555555556 26.5 53.93888888888889 34 59.111111111111114 34C 64.28333333333333 34 68.71666666666667 28 73.8888888888889 28C 79.06111111111112 28 83.49444444444445 43 88.66666666666667 43C 93.8388888888889 43 98.27222222222224 22.5 103.44444444444446 22.5C 108.61666666666667 22.5 113.05000000000001 29.5 118.22222222222223 29.5C 123.39444444444445 29.5 127.82777777777778 15.5 133 15.5"
                                                      pathFrom="M 0 50 L 0 50 L 14.777777777777779 50 L 29.555555555555557 50 L 44.333333333333336 50 L 59.111111111111114 50 L 73.8888888888889 50 L 88.66666666666667 50 L 103.44444444444446 50 L 118.22222222222223 50 L 133 50"
                                                      fill-rule="evenodd"></path>
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <div class="card p-2 mt-2  d-flex flex-row align-items-center header-toolbar-actions" style="border-radius: 15px;"
                          :class="!widthMd(1000)? 'pr-3 pl-2' : ''">
                        <div class="toolbar-select mr-2" v-if="widthMd(960, '>')">
                            <span class="toolbar-select-label">
                                <i class="icon-grid"></i>
                                {{ t('NAV.ALLOTMENT_S') }}:
                            </span>
                            <div class="toolbar-select-control">
                                <Select2 :settings="{ width: '100%', placeholder:  t('LOTS.ALLOTMENT')}" :options="allotments"
                                         v-model="allotmentId" @select="changeAllotment($event)"/>
                            </div>
                        </div>
                        <div class="align-self-center mr-2">
                            <a class="btn btn-primary " id="filter" data-toggle="modal" data-target="#customModalTwo"
                               @click="setModalFilter" >
                                Filtro
                            </a>
                        </div>
                        <div class="align-self-center" v-if="allotmentId">
                            <a class="btn btn-custom bg-btn" data-toggle="modal" data-target="#customModalTwo"
                               @click="setRegisterModal" id="new" data-cy="btn-new-page-header">
                                <i class="icon-circle-with-plus"></i> Novo
                            </a>
                        </div>
                    </div>
                </div>
            </template>
        </page-header>
        <div class="card p-2 mb-1" v-if="!items?.validations && items.data?.length">
            <div class="row mw-100">
                <div class="col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10 align-self-center">
                    <div class="tags-block ml-2 row left-content">
                        <div class="tags">
                            <div class="mr-2">
                                <i class="icon-label" :style="{'color':translateColorStatus('APROVADA')}"></i>
                                {{ translateStatus('APROVADA') }}
                            </div>
                        </div>
                        <div class="tags">
                            <div class="mr-2">
                                <i class="icon-label" :style="{'color':translateColorStatus('EM AVALIAÇÃO')}"></i>
                                {{ translateStatus('EM AVALIAÇÃO') }}
                            </div>
                        </div>
                        <div class="tags">
                            <div class="mr-2">
                                <i class="icon-label" :style="{'color':translateColorStatus('EXPIRADA')}"></i>
                                {{ translateStatus('EXPIRADA') }}
                            </div>
                        </div>
                        <div class="tags">
                            <div class="mr-2">
                                <i class="icon-label" :style="{'color':translateColorStatus('PENDENTE')}"></i>
                                {{ translateStatus('PENDENTE') }}
                            </div>
                        </div>
                        <div class="tags">
                            <div class="mr-2">
                                <i class="icon-label" :style="{'color':translateColorStatus('REJEITADA')}"></i>
                                {{ translateStatus('REJEITADA') }}
                            </div>
                        </div>
                        <div class="tags">
                            <div class="mr-2">
                                <i class="icon-label" :style="{'color':translateColorStatus('CANCELADA')}"></i>
                                {{ translateStatus('CANCELADA') }}
                            </div>
                        </div>
                        <div class="tags">
                            <div class="mr-2">
                                <i class="icon-label" :style="{'color':translateColorStatus('VENDA CANCELADA')}"></i>
                                {{ translateStatus('VENDA CANCELADA') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-2 text-right pr-0" v-if="this.$hasPermission('group_adm', true)">
                    <div data-cy="lot_index_dropdown" class="pointer" id="import-buttom" data-toggle="dropdown" style="font-size: 20px">
                        <i class="icon-menu"/>
                    </div>
                    <div class="dropdown-menu dropdown-menu-right dropdown-black dropdown-lot w-auto"
                         id="dropdown-import">
                        <div class="dropdown-item bg-hover-black w-auto">
                            <a class="row item-custom2 ml-1 text-white pr-2"
                               v-if="this.$hasPermission('proposal_index', true)"
                               @click="exportInPdf">
                                <i class="icon-download mr-1 font-15"/>
                                Exportar em PDF
                            </a>
                        </div>
                        <div class="dropdown-item bg-hover-black w-auto">
                            <a class="row item-custom2 ml-1 text-white pr-2"
                               v-if="this.$hasPermission('proposal_index', true)"
                               @click="exportInXlsx">
                                <i class="icon-download mr-1 font-15"/>
                                Exportar em XLSX
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card mb-1" v-if="hastwoAllotments && widthMd(961, '<')">
            <div class="card-body pt-1 pl-3 row pb-2">
                <div class="col-10 col-xl-3 col-md-3">
                    <label for="state">{{ t('NAV.ALLOTMENT') }}</label>
                    <Select2 :settings="{ width: '100%', placeholder:  t('LOTS.ALLOTMENT')}" :options="allotments"
                             v-model="allotmentId" @select="changeAllotment($event)"/>
                </div>
            </div>
        </div>
        <div class="data-list-card card" v-if="!items?.validations && items.data?.length && !widthMd(575)">
            <div class="data-list-card__header">
                <span class="data-list-card__title">{{ t('PROPOSAL.INDEX') }}</span>
                <span class="data-list-card__count">{{ items.data.length }}</span>
            </div>
            <div class="data-list-card__body">
                <div class="table-responsive">
                    <table class="table table-hover data-list-table mb-0">
                        <thead>
                        <tr>
                            <th class="text-center">N°</th>
                            <th class="text-center">{{ t('PROPOSAL.INFO') }}</th>
                            <th class="text-center">{{ t('PROPOSAL.CLIENT') }}</th>
                            <th class="text-center">{{ t('PROPOSAL.STATUS') }}</th>
                            <th class="text-center">{{ t('CONTRACT.STATUS_RESERVE') }}</th>
                            <th class="text-center">{{ t('PROPOSAL.REALTOR') }}</th>
                            <th class="text-center">Q.</th>
                            <th class="text-center">L.</th>
                            <th class="text-center">Assinatura</th>
                            <th class="text-center">{{ t('PROPOSAL.DATE_CREATE') }}</th>
                            <th class="text-center">{{ t('PROPOSAL.EXPIRED') }}</th>
                            <th class="text-center">{{ t('PROPOSAL.IS_IMPRESS') }}</th>
                            <th class="text-center">Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(iten, key) in items.data" :key="iten.id">
                            <td class="text-center pt-2 pb-2">
                                <span class="data-list-table__badge data-list-table__badge--primary">{{ getNumberProposal(iten) }}</span>
                            </td>
                            <td class="text-center pt-2 pb-2" @mouseleave="setModalHoover(`dropdownMenu${key}`, $event)"
                                @mouseenter="setModalHoover(`dropdownMenu${key}`, $event)">
                                <div id="dropInfo w-100">
                                    <div class="dropdown"
                                    >
                                        <i class="icon-info-with-circle"
                                           :id="`dropdownMenu${key}`"
                                           data-toggle="dropdown"
                                           aria-haspopup="true"
                                           aria-expanded="false"></i>
                                        <div class="dropdown-menu p-2" :aria-labelledby="`dropdownMenu${key}`"
                                             style="min-width: 40rem; max-height: 400px" :style="dropdownStyle">
                                            <div class="row mb-2 pt-0 p-2">
                                                <div class="col-12" v-if="iten.motive_reject && iten.status === 'REJEITADA'">
                                                    <div class="form-group">
                                                        <label>Motivo da rejeição:</label>
                                                        <div class=" pl-2 p-1 border">
                                                            <p>{{ iten.motive_reject }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12" v-if="iten.motive_pending && iten.status === 'PENDENTE'">
                                                    <div class="form-group">
                                                        <label>Pendência:</label>
                                                        <div class=" pl-2 p-1 border">
                                                            <p>{{ iten.motive_pending }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-12" v-if="iten.motive_reject">
                                                    <div class="form-group">
                                                        <label>Parcelas:</label>
                                                    </div>
                                                </div>
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4">
                                                    <div class="font-weight-bolder mt-2 ml-4 text-left">
                                                        {{ t('PROPOSAL.PARCEL_CONFIG.TYPE') }}
                                                    </div>
                                                </div>
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4">
                                                    <div class="font-weight-bolder mt-2 ml-4 text-left">
                                                        {{ t('PROPOSAL.PARCEL_CONFIG.VALUE') }}
                                                    </div>
                                                </div>
                                                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4">
                                                    <div class="font-weight-bolder mt-2 text-left">
                                                        {{ t('PROPOSAL.PARCEL_CONFIG.NUMBER_PARCELS') }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-for="(parcel, key) in iten?.parcel_configs" :key="key"
                                                 :class="key != 0 ? 'border-top2': ''">
                                                <div class="row mw-100 space-between mt-2">
                                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4">
                                                        <div class="list-primary hide-text">
                                                            <div class="w-auto">
                                                                {{ parcel.name }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4">
                                                        <div class="list-primary hide-text">
                                                            <div class="w-auto">
                                                                {{ toCurrency(parcel.value) }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4">
                                                        <div class="list-primary hide-text">
                                                            <div class="w-auto">
                                                                {{ parcel.number_parcels }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="pt-2 pb-2 data-list-table__primary-text proposal-client-list" :title="getNameClient(iten)">{{ getNameClient(iten) }}</td>
                            <td class="text-center pt-2 pb-2">
                                <div class="font-weight-bold d-flex justify-content-center w-100"
                                     style="width: 130px;" id="status">
                                    <div class="rounded-pill pb-1 pt-1 card m-0 pl-3 pr-3 dynamic-background-card dynamic-text-color"
                                         style="min-width: 130px"
                                         :style="{'--dynamic-bg': translateColorStatus(iten.status), '--dynamic-color': 'white'}">
                                        {{ translateStatus(iten.status) }}
                                    </div>
                                </div>
                            </td>
                            <td class="text-center pt-2 pb-2">{{ iten?.reserve?.reserve_status?.name }}</td>
                            <td class="pt-2 pb-2 data-list-table__muted-text">{{ iten.reserve?.realtor?.name ? iten.reserve?.realtor?.name : 'Indefinido' }}</td>
                            <td class="text-center pt-2 pb-2"><span class="data-list-table__badge">{{ iten.properties?.block }}</span></td>
                            <td class="text-center pt-2 pb-2"><span class="data-list-table__badge">{{ iten.properties?.name }}</span></td>
                            <td class="text-center pt-2 pb-2">
                                <div v-if="iten?.click_sign_documents?.status"
                                     :style="{'--dynamic-bg': translateColorStatusAssign(iten?.click_sign_documents?.status), '--dynamic-color': 'white', 'margin-bottom': '0'}"
                                     class="card text-white font-weight-bold p-1 dynamic-background-card dynamic-text-color" style="font-size: 12px">
                                    {{ getStatusClickSing(iten?.click_sign_documents?.status) }}
                                </div>
                                <div v-else style="font-size: 12px"
                                >{{ getStatusClickSing(iten?.click_sign_documents?.status) }}
                                </div>
                            </td>
                            <td class="text-center pt-2 pb-2">{{ endDateFormat(iten.created_at, true) }}</td>
                            <td class="text-center pt-2 pb-2">{{
                                    timeExpirationNow[iten.id]?.countdown ? timeExpirationNow[iten.id]?.countdown : 'Indefinido'
                                }}
                            </td>
                            <td class="text-center pt-2 pb-2">
                                <i class="icon-circle" style="font-size: 18px"
                                   :class="$hasPermission('proposal_alterImpress', true) ?'pointer' : ''"
                                   title="Marcar como Impressa"
                                   v-if="!iten.is_impress" @click="markImpress(iten)"></i>
                                <i class="icon-check-circle" style="font-size: 18px; color: #0e5e4e"
                                   :class="$hasPermission('proposal_alterImpress', true) ?'pointer' : ''"
                                   title="Marcar como não impressa"
                                   @click="markImpress(iten)"
                                   v-else></i>
                            </td>
                            <td class="text-center pt-2 pb-2" style="max-width: 10px">
                                <a type="button" data-toggle="dropdown" aria-haspopup="true"
                                   aria-expanded="false" class="data-list-table__action-badge"
                                   id="listDropdown">
                                    <i class="icon-more-horizontal" title="Opções"></i>
                                </a>
                                <optionsDropdowIndexComponent :index="this"
                                                              :iten="iten"></optionsDropdowIndexComponent>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="!items?.validations && items.data?.length && widthMd(575)">
            <div v-if="(items && items.data)">
                <div class="card" v-for="(iten) in  items.data" :key="iten.id">
                    <div class="pd-top-left-right pdt-1 aling justify-content-between">
                        <div>
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('RESERVE.STATUS') }}</b></label>
                                <div>
                                    <div class="text-left font-weight-bold "
                                         style="margin-bottom: -2px; width: 120px; text-align: justify" id="status">
                              <span class="rounded-pill pb-1 pt-1 text-center card dynamic-background-card dynamic-text-color"
                                    :style="{'--dynamic-bg': translateColorStatus(iten.status), '--dynamic-color': 'white'}">
                                 {{ this.translateStatus(iten.status) }}
                              </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('PROPERTIES.BLOCK') }}</b></label>
                                <div>{{ iten.properties?.block }}</div>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('PROPERTIES.NAME') }}</b></label>
                                <div>{{ iten.properties?.name }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="pd-top-left-right aling justify-content-between">
                        <div>
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('RESERVE.REALTOR') }}</b></label>
                                <div>{{ iten.reserve?.realtor?.name ? iten.reserve?.realtor?.name : 'Indefinido' }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="pd-top-left-right aling justify-content-between">
                        <div>
                            <div class="form-group">
                                <label class="mb-2"><b>{{ t('RESERVE.CLIENT') }}</b></label>
                                <div>{{ getNameClient(iten) }}</div>
                            </div>
                        </div>

                    </div>
                    <div class="pd-top-left-right aling justify-content-between">
                        <div>
                            <div class="form-group">
                                <label class="mb-2"><b>N°</b></label>
                                <div> {{ getNumberProposal(iten) }}</div>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label class="mb-2"><b>{{ this.t('PROPOSAL.EXPIRED') }}</b></label>
                                <div> {{ endDateFormat(iten.end_date) }}</div>
                            </div>
                        </div>
                        <div class="text-center">
                            <div class="form-group">
                                <label class="mb-2"><b>{{
                                        t('ACTIONS.LABEL')
                                    }}</b></label>
                                <div>
                                    <div class="text-center pt-2 pb-2" style="max-width: 10px">
                                        <a type="button" data-toggle="dropdown" aria-haspopup="true"
                                           aria-expanded="false" class="w-50"
                                           style="font-size: 20px">
                                            <i class="icon-more-horizontal" title="Opções"></i>
                                        </a>
                                        <optionsDropdowIndexComponent :index="this"
                                                                      :iten="iten"></optionsDropdowIndexComponent>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-if="items && (items?.validations || !items?.data?.length)">
            <div class="card-header"></div>
            <div class="card-body pt-0">
                <div class="text-center">
                    <h5>{{ t('PROPOSAL.PROPOSAL_NOT_FOUND') }}</h5>
                </div>
            </div>
        </div>
        <modal :modal-extra-large="modalChoose === 4 || modalChoose === 6" :modal-x-xl="modalChoose === 7" :modal-xl="modalChoose !== 4 && modalChoose !== 6 && modalChoose !== 7" :title-modal="modalTitle"
        @close="closeModal">
            <template v-slot:title>{{ t(modalTitle) }}</template>
            <edit-proposal-component v-if="modalChoose === 1" :proposal-index="proposal"></edit-proposal-component>
            <view-document-click-sign-component v-if="modalChoose === 2"
                                                :itens-index="documentClickSing"></view-document-click-sign-component>
            <filter-proposal-component v-if="modalChoose === 3" :perPageIndex="perPage" @search="filterProposal"
                                       @close="closeFilter()"></filter-proposal-component>
            <aproveProposalModal @aproved="aproved" :reserve="proposals" v-if="modalChoose === 4"
                                 :id="idProposalAprove"></aproveProposalModal>
            <listPersonDownloadFich v-if="modalChoose === 5" :clients="clientsForFich" :withProposal="withProposal"></listPersonDownloadFich>
            <create-proposal-component v-if="modalChoose === 6"></create-proposal-component>
            <click-sign-request-review-component v-if="modalChoose === 7"
                                                 :review="clickSignReview"
                                                 :loading="clickSignReviewLoading"
                                                 warning="Demais propostas em avaliação para esta reserva serão rejeitadas após a confirmação."
                                                 @cancel="closeClickSignReview"
                                                 @confirm="confirmClickSignReview"></click-sign-request-review-component>
        </modal>
        <modalRejectProposal position="one" :proposal-index="proposalReject" @proposalRejected="index()"
                             :modal-instance="this.modalRejectInstance"></modalRejectProposal>
        <modalPendingProposal position="one" :proposal-index="proposalPending" @proposalPended="index()"
                              :modal-instance="this.modalPendingInstance"></modalPendingProposal>
        <div class="row gutters">
            <div class="col-12">
                <pagination-component v-if="items && items.data && items.data[0]" :items="items" :to="'/propostas'"
                                      :have-per-page="!widthMd(1000)"
                                      :per-page="perPage"
                                      :paginate="paginate"
                                      @changePage="index(filter, $event)"
                                      @changePaginate="changePaginate"></pagination-component>
            </div>
        </div>
        <div>
            <modal-select-allotment v-if="allotments" :showModal="showAllotmentSelect"
                                    scope-allotment
                                    @showModal="showAllotmentSelect = $event" @allotmentSelected="allotmentSelected">
            </modal-select-allotment>
        </div>
        <upload-modal :uploadFile="uploadFile" @upload="uploadFile = $event"
                      @import="uploadDocument($event)"></upload-modal>
    </div>
</template>

<script>

import {mapState} from 'vuex';
import {closePendingTab, openPendingTab, showPdfInTab} from '@/Helpers/PdfTab';
import {useI18n} from 'vue-i18n';
import Drive from '../../services/Drive';
import modal from '../../components/modal';
import widthMd from '../../mixins/widthMd';
import {useToast} from 'vue-toastification';
import Select2 from 'vue3-select2-component';
import isReator from '../../mixins/isReator';
import Proposal from '../../services/Proposal';
import EditProposalComponent from './EditProposalComponent';
import ConfigClickSign from '../../services/ConfigClickSign';
import pageHeader from '../../components/layouts/pageHeader';
import uploadModal from '../../components/layouts/uploadModal';
import FilterProposalComponent from './FilterProposalComponent';
import modalSelectAllotment from '../allotment/modalSelectAllotmentComponent';
import ViewDocumentClickSignComponent from './ViewDocumentClickSignComponent';
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import PaginationComponent from '../../components/layouts/PaginationComponent';
import optionsDropdowIndexComponent from './optionsDropdowIndexComponent';
import Reserve from '../../services/Reserves';
import aproveProposalModal from './aproveProposalModal';
import {PDFDocument} from 'pdf-lib';
import Clients from '@/services/Clients';
import listPersonDownloadFich from './listPersonDownloadFich';
import modalRejectProposal from './modalRejectProposal';
import {Modal} from 'bootstrap';
import StatusProposal from '../../mixins/StatusProposal';
import modalPendingProposal from './modalPendingProposal';
import createProposalComponent from './createProposalComponent';
import updateCountdownProposal from '../../mixins/updateCountdownProposal';
import Dashboard from '../../services/Dashboard';
import UserCompanies from '../../services/UserCompanies';
import ClickSignRequestReviewComponent from './ClickSignRequestReviewComponent';

export default {
    name: 'indexProposalComponent',
    components: {
        pageHeader,
        ViewDocumentClickSignComponent,
        loadScreenComponent,
        PaginationComponent,
        modalSelectAllotment,
        Select2,
        modal,
        EditProposalComponent,
        FilterProposalComponent,
        uploadModal,
        optionsDropdowIndexComponent,
        aproveProposalModal,
        listPersonDownloadFich,
        modalRejectProposal,
        modalPendingProposal,
        createProposalComponent,
        ClickSignRequestReviewComponent,
    },
    computed: {
        ...mapState(['isLoading', 'hastwoAllotments', 'allotments', 'paginate'])
    },
    mixins: [isReator, widthMd, StatusProposal, updateCountdownProposal],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            timeExpirationNow: {},
            intervalExpiration: {},
            dropdownStyle: {},
            modalRejectInstance: null,
            modalPendingInstance: null,
            proposalReject: {},
            proposalPending:{},
            idProposalAprove: null,
            proposals: {},
            proposalId: null,
            uploadFile: false,
            perPage: null,
            documentClickSing: [],
            items: {},
            iten: {},
            showAllotmentSelect: false,
            allotmentId: null,
            filter: null,
            hasConfig: false,
            modalChoose: null,
            qtdProposalActive: null,
            modalTitle: '',
            proposal: {},
            clientsForFich: [],
            withProposal: null,
            clickSignReview: {},
            clickSignReviewId: null,
            clickSignReviewLoading: false,
        }
    },
    watch:{
        allotments: function () {
            if (!sessionStorage.getItem('allotmentIdScope')) {
                this.showAllotmentSelect = true;
            }
        },
    },
    async mounted() {
        this.$canAccess('proposal_index');
        if (sessionStorage.getItem('allotmentIdScope')){
            this.allotmentId = sessionStorage.getItem('allotmentIdScope');
            await this.chanceCustomScope(this.allotmentId);
            if (this.$hasPermission('Dashboard_proposals', true)) this.getQtdProposal();
            this.index();
        }else if (this.allotments?.length === 1) {
            this.allotmentId = this.allotments[0].id;
            sessionStorage.setItem('allotmentIdScope', this.allotmentId);
            await this.chanceCustomScope(this.allotmentId);
            if (this.$hasPermission('Dashboard_proposals', true)) this.getQtdProposal();
            this.index();
        }else if (this.allotments?.length){
            this.showAllotmentSelect = true;
        }
        this.checkHasConfig();
    },
    beforeUnmount() {
        Object.values(this.intervalExpiration)?.forEach((interval) => {
            clearInterval(interval);
        });
    },
    methods: {
        async chanceCustomScope(id) {
            await UserCompanies.chanceCustomScope(id).then(resp => {
                this.$setCustomToken(resp.data.accessToken, resp.data.refreshToken);
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        getQtdProposal(){
            Dashboard.getQtdProposal(this.allotmentId).then((resp) => {
                this.qtdProposalActive = resp.data?.proposals_active?.total;
            })
        },
        closeModal(){
            this.modalChoose = null;
            this.modalTitle = '';
        },
        setRegisterModal(){
            this.$store.commit('changeLoading', true);
            this.modalChoose = 6;
            this.modalTitle = 'Reservas para gerar proposta:';
        },
        aproved() {
            document.getElementById('closeX')?.click();
            this.index();
            this.modalChoose = null;
            this.modalTitle = '';
            this.idProposalAprove = null;
            this.proposals = {};
        },
        async setModalClientAnexView(iten, withProposal = false) {
            if (iten.clients.length === 1) {
                await this.printClientPdf(iten.clients?.find(i => i).clients, withProposal);
                document.getElementById('closeX')?.click();
            } else {
                this.modalChoose = 5;
                this.modalTitle = 'Download ficha do cliente';
                this.clientsForFich = iten.clients;
                this.withProposal = withProposal;
            }
        },
        async printClientPdf(iten, withProposal = null) {
            this.$store.commit('changeLoading', true);
            await Clients.exportPdfClient(iten.id, withProposal).then(async (response) => {
                if (response.data?.length) {
                    const mergedPdf = await PDFDocument.create();
                    for (const pdfObj of response.data) {
                        if (pdfObj?.basefile) {
                            const pdfBase64 = pdfObj.basefile;
                            const pdfBytes = this.base64ToUint8Array(pdfBase64);
                            try {
                                const pdfDoc = await PDFDocument.load(pdfBytes);
                                const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                                copiedPages.forEach((page) => mergedPdf.addPage(page));
                            } catch (err) {
                                const blob = new Blob([pdfBytes], {type: 'application/pdf'});
                                const url = URL.createObjectURL(blob);
                                const a = document.createElement('a');
                                a.href = url;
                                let fileName = response.data.find(i => i)?.name ? response.data.find(i => i)?.name : 'arquivoPessoas.pdf';
                                fileName = fileName?.replaceAll('.pdf', '');
                                fileName = fileName + (pdfObj?.name ? pdfObj?.name : '.pdf');
                                a.download = fileName;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                URL.revokeObjectURL(url);
                            }
                        }
                    }
                    const mergedPdfFile = await mergedPdf.save();
                    const blob = new Blob([mergedPdfFile], {type: 'application/pdf'});
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    let fileName = response.data.find(i => i)?.name ? response.data.find(i => i)?.name : 'arquivoPessoas.pdf'
                    a.href = url;
                    a.download = fileName;
                    a.style.display = 'none';
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            })
        },
        base64ToUint8Array(base64) {
            const base64Data = base64.replace(/^data:application\/pdf;base64,/, '');
            const binaryString = window.atob(base64Data);
            const len = binaryString.length;
            const bytes = new Uint8Array(len);
            for (let i = 0; i < len; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes;
        },
        setModalAproveProposal(iten) {
            this.idProposalAprove = iten.id;
            this.$store.commit('changeLoading', true)
            Reserve.showProposals(iten.reserve_id).then(resp => {
                if (resp.data?.business_proposal?.length === 1) {
                    setTimeout(() => document.getElementById('closeX')?.click(), 200);
                    this.$swal.fire({
                        title: `Realmente deseja aprovar a proposta N°${this.getNumberProposal(iten)} ?`,
                        text: '',
                        showCancelButton: true,
                        showCloseButton: true,
                        confirmButtonText: `Sim`,
                        cancelButtonText: 'Não'
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.$store.commit('changeLoading', true);
                            Proposal.aproveProposal(iten.id).then(() => {
                                this.index();
                                this.toast.success(this.t('PROPOSAL.APROVE_SUCCESS'));
                            }).catch(() => {
                                this.$store.commit('changeLoading', false);
                            })
                        }
                    });
                } else {
                    this.modalChoose = 4;
                    this.modalTitle = 'Aprovar Proposta';
                    this.proposals = resp.data;
                }
            }).catch(() => {
                this.proposals = {};
            }).finally(() => this.$store.commit('changeLoading', false));
        },
        reprintContract(item) {
            const win = openPendingTab();
            this.$store.commit('changeLoading', true);
            Proposal.reprintContract(item.id).then(resp => {
                this.$store.commit('changeLoading', false);
                showPdfInTab(win, resp.data);
            }).catch(() => {
                closePendingTab(win);
                this.$store.commit('changeLoading', false)
            })
        },
        exportInXlsx() {
            this.$store.commit('changeLoading', true);
            Proposal.indexProposal(this.filter, 1, this.allotmentId, this.perPage, 'xls').then(response => {
                if (!response?.data?.validations && response.data) {
                    const blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = 'propostas_export.xls';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            });
        },
        exportInPdf() {
            this.$store.commit('changeLoading', true);
            Proposal.indexProposal(this.filter, 1, this.allotmentId, this.perPage, 'pdf').then(resp => {
                if (!resp?.data?.validations && resp.data) {
                    const link = document.createElement('a');
                    link.href = resp.data;
                    link.download = 'exportar_propostas.pdf';
                    document.body.appendChild(link);
                    link.click();
                }
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            });
        },
        markImpress(iten) {
            if(!this.$hasPermission('proposal_alterImpress', true)) return;
            this.$swal.fire({
                title: `Realmente deseja marcar a proposta N° ${this.getNumberProposal(iten)}
                como ${iten.is_impress ? 'Não Impressa' : 'Impressa'} ?`,
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Sim`,
                cancelButtonText: 'Não',
            }).then(result => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    Proposal.alterImpress(iten.id).then((resp) => {
                        if (!resp?.data?.validations) {
                            iten.is_impress = resp.data.is_impress;
                        }
                    }).catch(err => this.errorMsg(err)).finally(() => this.$store.commit('changeLoading', false));
                }
            });
        },
        alterAvaliation(id) {
            this.$store.commit('changeLoading', true);
            Proposal.alterProposalForAvaliation(id).then(() => {
                this.toast.success(this.t('GENERAL.UPDATED_SUCCESSFULL'));
                this.index();
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            })
        },
        regenerateProposal(id) {
            this.$swal.fire({
                title: `Realmente deseja atualizar a proposta?`,
                text: 'Esta ação restaura a proposta com base no template vinculado, quaisquer edições feitas no texto da proposta serão perdidas!',
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Gerar`,
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    Proposal.regenerateProposal(id).then((resp) => {
                        this.downloadBase64PDF(resp.data, 'proposta.pdf');
                        this.toast.success(this.t('GENERAL.UPDATED_SUCCESSFULL'));
                        this.index();
                    }).catch((err) => {
                        this.$store.commit('changeLoading', false);
                        this.errorMsg(err);
                    })
                }
            });
        },
        downloadBase64PDF(base64, fileName) {
            base64 = base64.split(',')[1] || base64;
            const byteCharacters = atob(base64);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {type: 'application/pdf'});
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName || 'documento.pdf';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        },
        canSocityClickSign(status) {
            if (!status) {
                return true;
            }
            switch (status) {
                case 3:
                case 4:
                case 5:
                case 7:
                    return true;
            }
            return false;
        },
        isAssingManual(item) {
            if (item?.status !== 6) {
                return false;
            }
            return true;
        },
        deleteAssignManual(id) {
            this.$swal.fire({
                title: `Realmente deseja deletar a assinatura manual`,
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Sim`,
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    Proposal.deleteProposalAssinedManual(id).then(() => {
                        this.toast.success(this.t('GENERAL.MSG.DELETED_SUCCESS'));
                        this.index();
                    }).catch((err) => {
                        this.$store.commit('changeLoading', false);
                        if (err?.response?.data?.description) {
                            this.toast.error(err.response.data.description);
                        } else {
                            this.errorMsg(err);
                        }
                    })
                }
            });
        },
        async uploadDocument(file) {
            if (!file) return this.toast.error(this.t('CLIENTS.DOCUMENTS.FILE_EMPTY'));
            this.$store.commit('changeLoading', true);
            let formData = new FormData();
            formData.append('file', file);
            formData.append('context_id', this.proposalId);
            formData.append('context', 'propostas');
            Drive.uploadDocument(formData, true).then((resp) => {
                if (resp.data.code) {
                    this.toast.success(resp.data.description);
                } else {
                    this.toast.success(this.t('PROPOSAL.SOLICIT_ASSIGN_MANUAL_SUCESS'));
                }
                this.index();
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                if (err?.response?.data?.description) {
                    this.toast.error(err.response.data.description);
                } else {
                    this.errorMsg(err);
                }
            }).finally(() => {
                this.$store.commit('changeLoading', false)
            })
        },
        changePaginate(perPage) {
            this.perPage = perPage;
            this.index(this.filter);
        },
        filterProposal(items, filter, allotmentId) {
            this.items = items.data;
            this.filter = filter;
            this.allotmentId = allotmentId;
        },
        closeFilter() {
            document.getElementById('closeX')?.click();
            this.filter = null;
            this.modalChoose = null;
            this.index();
        },
        setModalFilter() {
            this.modalTitle = 'ACTIONS.FILTER';
            this.modalChoose = 3;
        },
        checkHasConfig() {
            ConfigClickSign.index().then(resp => {
                this.hasConfig = !!resp.data?.data?.length;
            }).catch(() => {
                this.hasConfig = false;
            })
        },
        async allotmentSelected() {
            this.allotmentId = sessionStorage.getItem('allotmentIdScope');
            await this.chanceCustomScope(this.allotmentId);
            if (this.$hasPermission('Dashboard_proposals', true)) this.getQtdProposal();
            this.index();
        },
        viewDocumentClickSing(id, iten) {
            this.$store.commit('changeLoading', true);
            if (iten?.click_sign_documents?.id && this.isAssingManual(iten.click_sign_documents)) {
                Proposal.viewProposalAssinedManual(iten.id).then((response) => {
                    const blob = new Blob([response.data], {type: 'application/pdf'});
                    const url = window.URL.createObjectURL(blob);
                    window.open(url, '_blank');
                    document.getElementById('closeX').click();
                    this.$store.commit('changeLoading', false);
                }).catch((err) => {
                    document.getElementById('closeX').click();
                    this.$store.commit('changeLoading', false);
                    this.errorMsg(err);
                })
                return;
            }
            Proposal.showDocumentClickSign(id).then((resp) => {
                this.modalChoose = 2;
                this.modalTitle = this.t('PROPOSAL.DOCUMENTS');
                resp.data.open = true;
                this.documentClickSing = [resp.data];
                this.$store.commit('changeLoading', false);
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                if (err.response?.data?.validations?.message) {
                    this.toast.error(err.response.data.validations.message);
                }
            });
        },
        cancelClickSing(id) {
            this.$swal.fire({
                title: `Realmente deseja cancelar a assinatura`,
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: `Sim`,
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.commit('changeLoading', true);
                    Proposal.cancelClickSign(id).then(() => {
                        this.index();
                        this.toast.success('Assinatura Cancelada com sucesso!');
                    }).catch((err) => {
                        this.$store.commit('changeLoading', false);
                        if (err.response?.data?.validations?.message) {
                            this.toast.error(err.response.data.validations.message);
                        }
                    })
                }
            });
        },
        setFile(id) {
            this.proposalId = id;
            this.uploadFile = true;
        },
        solicitClickSing(id) {
            this.$store.commit('changeLoading', true);
            Proposal.previewClickSign(id).then((resp) => {
                this.clickSignReview = resp.data;
                this.clickSignReviewId = id;
                this.clickSignReviewLoading = false;
                this.modalTitle = 'Conferir solicitação de assinatura';
                this.modalChoose = 7;
                this.$store.commit('changeLoading', false);
                this.$nextTick(() => {
                    const modalElement = document.getElementById('customModalTwo');
                    if (modalElement) new Modal(modalElement).show();
                });
            }).catch((err) => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        closeClickSignReview() {
            this.clickSignReview = {};
            this.clickSignReviewId = null;
            this.clickSignReviewLoading = false;
            this.modalChoose = null;
            this.modalTitle = '';
            document.getElementById('closeX')?.click();
        },
        confirmClickSignReview(body = {}) {
            if (!this.clickSignReviewId) return;
            this.clickSignReviewLoading = true;
            Proposal.solicitClickSign(this.clickSignReviewId, body).then(() => {
                this.toast.success('Assinatura de Documento requisitada com sucesso!');
                this.closeClickSignReview();
                this.index();
            }).catch((err) => {
                this.clickSignReviewLoading = false;
                this.errorMsg(err);
            });
        },
        setModalEdit(id) {
            this.modalTitle = 'PROPOSAL.EDIT_PROPOSAL';
            this.modalChoose = 1;
            this.$store.commit('changeLoading', true);
            Proposal.show(id).then((resp) => {
                this.proposal = resp.data;
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            })
        },
        setModalHoover(id, e) {
            let el = document.getElementById(id);
            if (el) {
                if (el.nextElementSibling.classList.contains('show')) {
                    el.nextElementSibling.classList.remove('show');
                } else {
                    el.nextElementSibling.classList.add('show');
                    let buttonRect = e.target.getBoundingClientRect()
                    const windowHeight = window.innerHeight;
                    const dropdownHeight = el.nextElementSibling.offsetHeight;
                    if (buttonRect.bottom + dropdownHeight > windowHeight) {
                        this.dropdownStyle = {
                            position: 'fixed',
                            top: `${windowHeight - (dropdownHeight + 20)}px`,
                            left: `${buttonRect.left}px`,
                        };
                    } else {
                        this.dropdownStyle = {
                            position: 'fixed',
                            top: `${buttonRect.bottom}px`,
                            left: `${buttonRect.left}px`,
                        };
                    }
                }
            }
        },
        toCurrency(value) {
            if (value === null) return 'Indisponível';
            return Intl.NumberFormat('pt-br', {style: 'currency', currency: 'BRL'}).format(value);
        },
        async changeAllotment({id}) {
            this.modalChoose = null;
            sessionStorage.removeItem('allotmentIdScope');
            sessionStorage.setItem('allotmentIdScope', id);
            this.allotmentId = id
            await this.chanceCustomScope(id);
            if (this.$hasPermission('Dashboard_proposals', true)) this.getQtdProposal();
            this.index();
        },
        getNumberProposal(iten) {
            let block = '';
            if (iten.properties?.block) {
                block = iten.properties.block.replace(/^0+/, '');
            }
            let lot = '';
            if (iten.properties?.name) {
                lot = iten.properties.name.replace(/^0+/, '');
            }
            if (iten.created_at) {
                let date = iten.created_at?.split('T');
                date = date[1]?.split(':');
                let sec = date[2]?.split('.')
                return `${block}${lot}${date[0]}${date[1]}${sec[0]}`;
            }
            return `${block}${lot}`;
        },
        getNameClient(iten) {
            let name = null;
            iten.clients.forEach((item) => {
                if (!item.clients?.name) return;
                name = name !== null ? item.clients.name + ' ,' + name : item.clients.name;
            });
            if (!name) return 'Nenhum cliente vinculado';
            return name;
        },
        endDateFormat(value, created = false) {
            if (value && !created) {
                let dateAndTime = value.split(' ');
                let date = dateAndTime[0].split('-');
                let time = dateAndTime[1].split(':');
                return `${date[2]}/${date[1]}/${date[0]} ${time[0]}:${time[1]}`;
            } else if (value && created) {
                let dateAndTime = value.split('T');
                let date = dateAndTime[0].split('-');
                let time = dateAndTime[1].split(':');
                return `${date[2]}/${date[1]}/${date[0]} ${time[0]}:${time[1]}`;
            }
            return 'Indefinido'
        },
        async setFilterModal() {
            this.$store.commit('changeLoading', true)
            this.indexRealtor(this.allotmentId);
            await this.getLots(this.allotmentId)
            this.indexBlocks(this.allotmentId);
            this.indexStatus(this.allotmentId);
            this.wichModal = 5;
            this.modalTitle = 'ACTIONS.FILTER';
            this.$store.commit('changeLoading', false)
        },
        setModalRejectProposal(item) {
            const modalElement = document.getElementById('modalShow');
            new Modal(modalElement).show();
            this.modalRejectInstance = new Modal(modalElement);
            this.modalRejectInstance.show();
            this.proposalReject = item;
        },
        alterPending(item) {
            const modalElement = document.getElementById('modalPending');
            new Modal(modalElement).show();
            this.modalPendingInstance = new Modal(modalElement);
            this.modalPendingInstance.show()
            this.proposalPending = item;
        },
        async generateContract(item) {
            this.$store.commit('changeLoading', true);
            await Proposal.createContract(item.id).then(res => {
                this.toast.success(this.t('PROPOSAL.CONTRACT_GENERATED'));
                const byteCharacters = atob(res.data.split(",")[1]);
                const byteNumbers = new Uint8Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const blob = new Blob([byteNumbers], {type: "application/pdf"});
                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = "contrato.pdf";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
               // sessionStorage.setItem('contractAllotmentId', sessionStorage.getItem('allotmentIdScope'));
                this.$router.push({name: 'IndexContracts'});
            }).catch(err => this.errorMsg(err))
                    .finally(() => this.$store.commit('changeLoading', false));
        },
        reprintProposal(item) {
            const win = openPendingTab();
            this.$store.commit('changeLoading', true);
            Proposal.reprintProposal(item.id).then(resp => {
                this.$store.commit('changeLoading', false);
                showPdfInTab(win, resp.data);
            }).catch(() => {
                closePendingTab(win);
                this.$store.commit('changeLoading', false)
            })
        },
        index(filter = null, page = 1, exportIn = null) {
            Object.values(this.intervalExpiration)?.forEach((interval) => {
                clearInterval(interval);
            });
            this.filter = filter;
            this.$store.commit('changeLoading', true);
            Proposal.indexProposal(filter, page, this.allotmentId, this.perPage, exportIn)
                    .then(resp => {
                        resp?.data?.data?.forEach(i => {
                            this.intervalExpiration[i.id] = setInterval(() => this.updateCountdown(i), 100);
                        });
                        this.items = resp.data
                    })
                    .finally(() => this.$store.commit('changeLoading', false));
        }
    }
}
</script>

<style scoped>
.proposal-client-list {
    max-width: 260px;
    min-width: 210px;
    overflow: hidden;
    text-overflow: initial;
    white-space: normal;
    word-break: break-word;
}

.proposal-table-card {
    border: 1px solid #e4eeea;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(15, 39, 54, .06);
    overflow: visible;
}

.proposal-table-card__header {
    align-items: center;
    background: linear-gradient(180deg, #fbfdfc 0%, #f6faf8 100%);
    border-bottom: 1px solid #e7f0ec;
    border-radius: 16px 16px 0 0;
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
}

.proposal-table-card__title {
    color: #263238;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
}

.proposal-table-card__count {
    background: #eaf5f1;
    border-radius: 999px;
    color: #0e5e4e;
    font-size: 12px;
    font-weight: 700;
    padding: 6px 12px;
}

.proposal-table-card__body {
    padding: 0;
}

.proposal-table-card__body .table-responsive {
    border-radius: 0 0 16px 16px;
    overflow: hidden;
}

.proposal-table {
    border-collapse: collapse;
    border-spacing: 0;
}

.proposal-table thead th {
    background: #fbfdfc;
    border: 0;
    color: #8a949e;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .04em;
    padding-bottom: 10px;
    padding-top: 12px;
    text-transform: uppercase;
    white-space: nowrap;
}

.proposal-table tbody tr {
    background: #fff;
    border-bottom: 1px solid #edf3f0;
    transition: background .18s ease;
}

.proposal-table tbody tr:hover {
    background: #f8fbfa;
}

.proposal-table tbody td {
    border: 0;
    color: #47545c;
    font-size: 12px;
    line-height: 1.35;
    padding-bottom: 14px !important;
    padding-top: 14px !important;
    vertical-align: middle;
}

.proposal-table tbody tr:last-child {
    border-bottom: 0;
}

.proposal-number {
    background: #eef7f4;
    border: 1px solid #d7e9e3;
    border-radius: 999px;
    color: #263238;
    display: inline-block;
    font-weight: 700;
    min-width: 76px;
    padding: 5px 9px;
}

.proposal-client {
    color: #263238;
    font-weight: 700;
    max-width: 180px;
    min-width: 150px;
}

.proposal-realtor {
    color: #6c7880;
    max-width: 150px;
    min-width: 120px;
}

.proposal-client,
.proposal-realtor {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.proposal-property-badge {
    background: #f5f8f7;
    border: 1px solid #e8efec;
    border-radius: 999px;
    color: #344047;
    display: inline-block;
    font-weight: 700;
    min-width: 34px;
    padding: 4px 8px;
}

.proposal-action-button {
    align-items: center;
    background: #eef7f4;
    border: 0;
    border-radius: 999px;
    color: #0e5e4e;
    display: inline-flex;
    font-size: 18px;
    height: 32px;
    justify-content: center;
    transition: background .18s ease, color .18s ease;
    width: 32px;
}

.proposal-action-button:hover {
    background: #dcefe8;
    color: #0e5e4e;
    text-decoration: none;
}

html.dark-theme .proposal-table-card {
    background: var(--dark-surface-2);
    border-color: var(--dark-border);
    box-shadow: var(--dark-shadow-soft);
}

html.dark-theme .proposal-table-card__header {
    background: linear-gradient(180deg, var(--dark-surface-2) 0%, var(--dark-surface) 100%);
    border-bottom-color: var(--dark-border);
}

html.dark-theme .proposal-table thead th {
    color: var(--dark-text-muted);
}

html.dark-theme .proposal-table-card__title,
html.dark-theme .proposal-client {
    color: var(--dark-text);
}

html.dark-theme .proposal-table-card__count {
    background: rgba(20, 184, 166, .14);
    color: var(--dark-primary);
}

html.dark-theme .proposal-table-card__body .table-responsive {
    border-color: var(--dark-border);
}

html.dark-theme .proposal-table thead th {
    background: var(--dark-surface-2);
}

html.dark-theme .proposal-table tbody tr {
    background: var(--dark-surface);
    border-bottom-color: var(--dark-border);
}

html.dark-theme .proposal-table tbody tr:hover {
    background: var(--dark-surface-2);
}

html.dark-theme .proposal-table tbody td {
    color: var(--dark-text-soft);
}

html.dark-theme .proposal-number {
    background: rgba(20, 184, 166, .14);
    border-color: rgba(20, 184, 166, .24);
    color: var(--dark-text);
}

html.dark-theme .proposal-realtor {
    color: var(--dark-text-muted);
}

html.dark-theme .proposal-property-badge,
html.dark-theme .proposal-action-button {
    background: rgba(30, 41, 59, .72);
    color: var(--dark-text-soft);
}

html.dark-theme .proposal-action-button:hover {
    background: rgba(20, 184, 166, .14);
    color: var(--dark-primary);
}

#dropInfo {
    position: absolute !important;
}

.task-list .task-block .dropdown-menu:before {
    border-bottom: 0px solid #262b31 !important;
}

.aling {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}

.pd-top-left-right {
    padding-top: 0.5rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}

.pdt-1 {
    padding-top: 1rem;
}

.dropdown-reserve {
    width: 175px;
    left: 10% !important;
}

@media screen and (max-width: 575px) {
    .pd-top-left-right {
        padding-top: 1rem;
        padding-left: 1rem;
        padding-right: 1rem;
    }

    .dropdown-reserve {
        left: 3% !important;
    }
}
</style>
